<div class="pr-xlarge-b table-wrapper">
  <table>
    <caption class="is-vishidden">
      {{
        'timetable.flightList.caption' | finLocalization
      }}
    </caption>
    <tbody>
      <tr class="nordic-blue-900-bg nordic-blue-900-border">
        <th
          scope="col"
          class="ps-xsmall-y pr-xxsmall-x font-body-2 medium-type align-center rounded-top-large rounded-top-left-large white-text"
        >
          {{ 'timetable.flightList.flight' | finLocalization }}
        </th>
        <th scope="col" class="ps-xsmall-y pr-xxsmall-x font-body-2 medium-type align-center white-text">
          {{ 'timetable.flightList.departure' | finLocalization }}
        </th>
        <th scope="col" class="ps-xsmall-y"></th>
        <th scope="col" class="ps-xsmall-y pr-xxsmall-x font-body-2 medium-type align-center white-text">
          {{ 'timetable.flightList.arrival' | finLocalization }}
        </th>
        <th scope="col" class="ps-xsmall-y pr-small-x font-body-2 medium-type align-center white-text">
          {{ 'timetable.flightList.duration' | finLocalization }}
        </th>
        <th scope="col" class="ps-xsmall-y pr-xxsmall-x rounded-top-large rounded-top-right-large"></th>
      </tr>
      <tr *ngIf="(items$ | async) === null || (items$ | async).length === 0" class="border">
        <td
          colspan="6"
          class="border-bottom border-left border-right rounded-bottom-left-large rounded-bottom-right-large"
        >
          <div class="ms-medium nordic-blue-900-text font-body-1" *ngIf="(loading$ | async) === false">
            {{
              ((search$ | async).origin && (search$ | async).destination
                ? 'timetable.flightList.noFlights'
                : 'timetable.flightList.selectDate'
              ) | finLocalization
            }}
          </div>
        </td>
      </tr>
      <tr
        role="button"
        tabindex="0"
        *ngFor="let item of items$ | async; let i = index; let lastRow = last"
        class="mr-xsmall-b border schedule-item"
        [attr.aria-labelledby]="'flightSummaryDetailsText-' + i"
        (click)="openModal($event, item)"
        (keyup)="rowKeyPress($event, item)"
      >
        <ng-container *ngIf="item.flights as flights">
          <td
            class="pr-xxsmall-x ps-medium-y border-left"
            [ngClass]="{
              'border-bottom': lastRow,
              'rounded-bottom-left-large': lastRow,
            }"
          >
            <div
              *ngFor="let flight of flights; let first = first; let last = last"
              class="flex-1 flex--middle font-body-1 nordic-blue-900-text"
            >
              {{ flight.flightNumber }}
            </div>
          </td>
          <td
            class="pr-xxsmall-x ps-medium-y align-center"
            [ngClass]="{
              'border-bottom': lastRow,
            }"
          >
            <div
              *ngFor="let flight of flights; let first = first; let last = last"
              class="flex--center font-body-1 medium-type nordic-blue-900-text"
            >
              {{ flight.departureTime }}
            </div>
          </td>
          <td
            class="ps-medium-y align-center"
            [ngClass]="{
              'border-bottom': lastRow,
            }"
          >
            <div class="flex flex--column">
              <div *ngFor="let flight of flights; let first = first; let last = last">
                <fcom-icon [name]="flight.icon" class="flex--nogrow flex--middle"></fcom-icon>
              </div>
            </div>
          </td>
          <td
            class="pr-xxsmall-x ps-medium-y align-center"
            [ngClass]="{
              'border-bottom': lastRow,
            }"
          >
            <div *ngFor="let flight of flights; let first = first; let last = last" class="flex flex--center">
              <div class="flex--center font-body-1 medium-type nordic-blue-900-text relative float-left">
                {{ flight.arrivalTime }}
                <div
                  *ngIf="flight.overnight"
                  class="flex--self-start absolute font-body-2 nordic-blue-900-text ps-xxsmall-l plus-one"
                >
                  +1
                </div>
              </div>
            </div>
          </td>
          <td
            class="pr-small-x ps-medium-y align-center"
            [ngClass]="{
              'border-bottom': lastRow,
            }"
          >
            <div class="flex-1 flex--center truncate overflow-hidden font-body-1 nordic-blue-900-text">
              {{ item.duration.hours + 'h ' + item.duration.minutes + 'min' }}
            </div>
          </td>
          <td
            class="border-right"
            [ngClass]="{
              'border-bottom': lastRow,
              'rounded-bottom-right-large': lastRow,
            }"
          >
            <div class="flex flex--end">
              <p [id]="'flightSummaryDetailsText-' + i" class="is-vishidden">
                {{
                  'timetable.flightSummaryDetails'
                    | finLocalization
                      : {
                          origin: item.origin$ | async,
                          departureTime: item.departureTime,
                          destination: item.destination$ | async,
                          arrivalTime: item.arrivalTime,
                          durationTime: item.duration.hours + 'h ' + item.duration.minutes + 'min',
                        }
                }}
              </p>
              <span
                class="dn-mobile db-tablet-up font-body-1 nordic-blue-900-text blue-light-hover medium-type underline truncate overflow-hidden"
              >
                {{ 'timetable.viewDetails' | finLocalization }}
                <fcom-icon [name]="SvgLibraryIcon.CHEVRON_RIGHT" class="flex--nogrow flex--middle"></fcom-icon>
              </span>
              <span class="db-mobile dn-mobile-up">
                <fcom-icon [name]="SvgLibraryIcon.CHEVRON_RIGHT" class="flex--nogrow flex--middle"></fcom-icon>
              </span>
            </div>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
</div>
<fcom-modal
  [title]="'timetable.flightList.viewDetails.title' | finLocalization"
  [buttons]="null"
  [(open)]="detailsModalOpen"
  (close)="closeModal()"
>
  <fin-itinerary-timeline
    [bound]="selectedBound$ | async"
    [locations]="locations$ | async"
    [boundType]="BoundType.outbound"
    class="block pr-medium"
  >
  </fin-itinerary-timeline>
</fcom-modal>
